<template>
  <div>
    <SafeHarborStagingEnvironmentsTable
      :service="service"
      :staging-environments="stagingEnvironments"
      :status="getStatus()"
      type="shared"
      class="mb-4"
    />
    <div>
      <Card :disableTitle="true">
        <div>
          <div class="mb-3">{{ $t("global.safe-harbor-try-our-staging-site") }}</div>
          <ul class="list-unstyled">
            <li class="mb-3">
              <h2>{{ $t("global.access") }}</h2>
              <span>{{ $t("global.safe-harbor-use-control-panel") }}</span>
            </li>
            <li class="mb-3">
              <h2>{{ $t("global.versions") }}</h2>
              <span>{{ $t("global.safe-harbor-try-different-versions") }}</span>
            </li>
            <li class="mb-3">
              <h2>{{ $t("global.lets-encrypt-ssl") }}</h2>
              <span>{{ $t("global.safe-harbor-lets-encrypt") }}</span>
            </li>
            <li class="mb-3">
              <h2>{{ $t("global.anonymize-data") }}</h2>
              <span>{{ $t("global.safe-harbor-anonymize-data") }}</span>
            </li>
          </ul>
          <a
            href="https://www.nexcess.net/cloud/development-sites/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("global.learn-more") }}
          </a>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import SafeHarborStagingEnvironmentsTable from "@/components/smart/tables/SafeHarborStagingEnvironmentsTable";
import Status from "@/classes/Status";
import store from "@/store";

export default {
  name: "SafeHarborStagingEnvironmentsPage",
  components: { Card, SafeHarborStagingEnvironmentsTable },
  setup() {
    const service = computed(() => store.getters["sharedHosts/getItem"]);
    const stagingEnvironments = computed(() => store.getters["safeHarbor/getStagingEnvironments"]);
    const status = computed(() => store.getters["safeHarbor/getStagingEnvironmentsStatus"]);
    const isUpdating = computed(() =>
      store.getters["safeHarbor/isStagingEnvironmentUpdating"](service.value.id)
    );

    const loadingStatus = new Status(Status.LOADING);
    const getStatus = () => (isUpdating.value ? loadingStatus : status.value);

    onMounted(() => {
      store.dispatch("safeHarbor/getStagingEnvironments", service.value.id);
    });

    return {
      getStatus,
      service,
      stagingEnvironments,
    };
  },
};
</script>
